import { render, staticRenderFns } from "./RouterGoAlertsListBtn.vue?vue&type=template&id=b0505118"
import script from "./RouterGoAlertsListBtn.vue?vue&type=script&lang=ts"
export * from "./RouterGoAlertsListBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports